/* Cabinet Giant: consent-aware campaign capture and verified Hulk iframe bridge.
 * Storefront campaign capture and successful design-request event bridge.
 * No email, phone, address, form answers, or purchase events are sent by this file.
 */
(function () {
  'use strict';
  if (window.CGDesignAttribution) return;
  var FORM = 'IvRmtfSVEHb7BDjxfAFpEQ';
  var HULK_ORIGIN = 'https://formbuilder.hulkapps.com';
  var CAMPAIGN_KEY = 'cg_design_campaign_v1';
  var REF_KEY = 'cg_design_lead_v1';
  var TTL = 90 * 24 * 60 * 60 * 1000;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'];
  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'oppref'];
  var published = Object.create(null);
  var pageOpenedMs = Date.now();
  var memoryReference = null;
  var memoryCampaign = {};
  function storage(kind) {
    try { return window[kind]; } catch (_) { return null; }
  }

  function read(storage, key) {
    try { return JSON.parse(storage.getItem(key) || 'null'); } catch (_) { return null; }
  }
  function write(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (_) { /* storage may be unavailable */ }
  }
  function remove(storage, key) {
    try { storage.removeItem(key); } catch (_) { /* storage may be unavailable */ }
  }
  function permissions() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p) return { analytics: false, marketing: false };
    try {
      return {
        analytics: p.analyticsProcessingAllowed() === true,
        marketing: p.marketingAllowed() === true && p.saleOfDataAllowed() === true
      };
    } catch (_) { return { analytics: false, marketing: false }; }
  }
  function clean(value, max) {
    return typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, max) : '';
  }
  function paidClick(touch) {
    return !!(touch && (touch.gclid || touch.gbraid || touch.wbraid || touch.oppref));
  }
  function paidTouch(touch) {
    return !!touch && (paidClick(touch) || /^(cpc|ppc|paid|paid[_-]social|paid[_-]search|display|cpm|retargeting|ads)$/i.test(touch.utm_medium || ''));
  }
  function strip(touch, consent) {
    if (!touch || !Number.isFinite(touch.timestamp_ms) || touch.timestamp_ms > Date.now() || Date.now() - touch.timestamp_ms > TTL) return null;
    var out = { timestamp_ms: touch.timestamp_ms, landing_path: clean(touch.landing_path, 512) };
    if (consent.analytics) UTM_KEYS.forEach(function (k) { if (touch[k]) out[k] = clean(touch[k], 256); });
    if (consent.marketing) CLICK_KEYS.forEach(function (k) { if (touch[k]) out[k] = clean(touch[k], 2048); });
    if (touch.capture_version === 2) out.capture_version = 2;
    // Version 1 could invent "facebook / paid" from fbclid alone. Its provenance is ambiguous.
    // Keep the source/click, but do not carry that inferred paid claim into future requests.
    if (touch.capture_version !== 2 && touch.fbclid && !paidClick(touch) && touch.utm_source === 'facebook' && touch.utm_medium === 'paid') {
      delete out.utm_medium;
    }
    return UTM_KEYS.concat(CLICK_KEYS).some(function (k) { return !!out[k]; }) ? out : null;
  }
  function capture() {
    var consent = permissions();
    var previous = read(storage('localStorage'), CAMPAIGN_KEY) || memoryCampaign;
    var state = {
      first_touch: strip(previous.first_touch, consent),
      last_campaign_touch: strip(previous.last_campaign_touch, consent),
      last_paid_touch: strip(previous.last_paid_touch, consent)
    };
    if (!paidTouch(state.last_paid_touch)) state.last_paid_touch = null;
    var params = new URLSearchParams(window.location.search);
    var touch = { timestamp_ms: pageOpenedMs, landing_path: window.location.pathname, capture_version: 2 };
    if (consent.analytics) UTM_KEYS.forEach(function (k) { var v = clean(params.get(k), 256); if (v) touch[k] = v; });
    if (consent.marketing) CLICK_KEYS.forEach(function (k) { var v = clean(params.get(k), 2048); if (v) touch[k] = v; });
    var hasClick = CLICK_KEYS.some(function (k) { return !!touch[k]; });
    if (!touch.utm_source && consent.analytics && hasClick) {
      touch.utm_source = touch.oppref ? 'chatgpt' : touch.fbclid ? 'facebook' : 'google';
    }
    if (!touch.utm_medium && consent.analytics && paidClick(touch)) touch.utm_medium = 'paid';
    var hasCampaign = UTM_KEYS.concat(CLICK_KEYS).some(function (k) { return !!touch[k]; });
    if (hasCampaign) {
      if (!state.first_touch) state.first_touch = touch;
      // A new campaign visit replaces its entire snapshot; identifiers from different clicks are never merged.
      state.last_campaign_touch = touch;
      if (paidTouch(touch)) {
        state.last_paid_touch = touch;
      }
    }
    memoryCampaign = state;
    if (state.first_touch || state.last_campaign_touch || state.last_paid_touch) write(storage('localStorage'), CAMPAIGN_KEY, state);
    else remove(storage('localStorage'), CAMPAIGN_KEY);
    return { consent: consent, campaigns: state };
  }
  function leadReference() {
    var existing = read(storage('sessionStorage'), REF_KEY);
    if (existing && /^CG-[0-9a-f-]{36}$/i.test(existing.id) && Date.now() - existing.created_ms < TTL) {
      memoryReference = existing;
    }
    if (!memoryReference) {
      var uuid = window.crypto.randomUUID ? window.crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var byte = new Uint8Array(1); window.crypto.getRandomValues(byte);
        var n = byte[0] & 15; return (c === 'x' ? n : (n & 3) | 8).toString(16);
      });
      memoryReference = { id: 'CG-' + uuid, created_ms: Date.now() };
      write(storage('sessionStorage'), REF_KEY, memoryReference);
    }
    return memoryReference;
  }
  function context() {
    var captured = capture();
    var ref = leadReference();
    var chosen = captured.campaigns.last_paid_touch || captured.campaigns.last_campaign_touch || captured.campaigns.first_touch || {};
    var fields = { lead_reference: ref.id };
    UTM_KEYS.concat(CLICK_KEYS).forEach(function (k) { fields[k] = chosen[k] || ''; });
    var snapshot = {
      schema_version: 1, form_uuid: FORM, lead_reference: ref.id,
      lead_reference_created_at: new Date(ref.created_ms).toISOString(),
      captured_at: new Date().toISOString(), form_page_path: window.location.pathname,
      consent: captured.consent, first_touch: captured.campaigns.first_touch,
      last_campaign_touch: captured.campaigns.last_campaign_touch, last_paid_touch: captured.campaigns.last_paid_touch
    };
    if (captured.consent.marketing) {
      ['_fbp', '_fbc'].forEach(function (k) {
        var cookie = document.cookie.split(';').map(function (s) { return s.trim(); }).find(function (s) { return s.indexOf(k + '=') === 0; });
        if (cookie) snapshot[k] = clean(cookie.slice(k.length + 1), 512);
      });
    }
    fields.design_attribution = JSON.stringify(snapshot);
    return fields;
  }
  function frame() { return document.getElementById('frame_' + FORM); }
  function sendContext() {
    var f = frame();
    if (f && f.contentWindow) f.contentWindow.postMessage({ type: 'cg_design_context', form_uuid: FORM, fields: context() }, HULK_ORIGIN);
  }
  window.addEventListener('message', function (event) {
    var f = frame();
    var data = event.data;
    if (!f || event.source !== f.contentWindow || event.origin !== HULK_ORIGIN || !data || data.form_uuid !== FORM) return;
    if (data.type === 'cg_design_context_request') sendContext();
    if (data.type === 'cg_design_submission_success') {
      var ref = memoryReference || read(storage('sessionStorage'), REF_KEY);
      if (!ref || data.lead_reference !== ref.id || published[ref.id]) return;
      published[ref.id] = true;
      // Hulk calls this only after it accepts the request. No event fires on button clicks or thank-you page views.
      var consent = permissions();
      if ((consent.analytics || consent.marketing) && window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish('cg_design_lead_submitted', {
          form_uuid: FORM, lead_reference: ref.id, event_id: 'design-lead-' + ref.id,
          submitted_at: new Date().toISOString()
        });
      }
      memoryReference = null;
      remove(storage('sessionStorage'), REF_KEY);
    }
  });
  document.addEventListener('visitorConsentCollected', function () { capture(); sendContext(); });
  window.CGDesignAttribution = { version: '1.0.1' };
  capture();
  // Load Shopify's consent API if the storefront hasn't already loaded it; never set the visitor's consent.
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) { capture(); sendContext(); } });
  }
})();
